/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from "react";
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from "semantic-ui-react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { UniversalLink } from "@plone/volto/components";

import { useGoogleAnalytics } from "volto-google-analytics";
const messages = defineMessages({
  copyright: {
    id: "Copyright",
    defaultMessage: "Copyright",
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>About</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/about-us/the-cra">
                        Who we are
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/about-us/our-team">
                        Our team
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/about-us/what-we-offer">
                        What we offer
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Media</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/in-the-media/media">
                        CRA in the media
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/in-the-media/videos">
                        Video
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Products</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/products/publication-search/socio-economic-survey">
                        Socio-Economic Survey
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/products/publication-search/strategic-intelligence">
                        Strategic Intelligence
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/products/publication-search/macro-review">
                        Macro Review
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/products/publication-search/fast-stats">
                        Fast Stats
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/products/publication-search/risk-alert">
                        Risk Alert
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/products/publication-search/client-notes">
                        Client Note
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Contact Us</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/about/contact">
                        Schedule a call
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/about/contact">
                        Arrange a briefing
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/subscribe">
                        Subscribe now
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                  <List.Header>
                    <h4>Quick Links</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/privacy-policy">
                        Privacy policy
                      </UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/terms-conditions">
                        Terms of use
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={6} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://twitter.com/centre_risk"
                            target="_blank"
                            title="X"
                          >
                            <i class="bi bi-twitter-x"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.youtube.com/channel/UCHRcn9vEaeKapV_EkfwFQJQ/"
                            target="_blank"
                            title="YouTube"
                          >
                            <i class="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.facebook.com/CentreForRiskAnalysis/"
                            target="_blank"
                            title="Facebook"
                          >
                            <i class="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.linkedin.com/company/centre-for-risk-analysis"
                            target="_blank"
                            title="LinkedIn"
                          >
                            <i class="bi bi-linkedin"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <FormattedMessage
                        id="{copyright} Centre for Risk Analysis (CRA) {current_year}"
                        defaultMessage="{copyright} Centre for Risk Analysis (CRA) {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of{" "}
                      <a
                        href="https://www.pexels.com"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Pexels
                      </a>{" "}
                      &{" "}
                      <a
                        href="https://unsplash.com"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Unsplash
                      </a>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        class="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-circle-fill"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank" rel="noreferrer">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
